export default "__VITE_ASSET__43885733__"